<template>
    <div class="order-Classification">
        <div class="Classification1">
            <div class="type">订单类型</div>
            <div class="list">
                <template v-for="(item,index) in orderList">
                    <div class="list-detail"
                         :key="index" v-if="item&&item.show">
                        <div class="detail-box">
                            <span class="num">{{item.count||0}}</span>
                            <span class="text">{{item.statusName}}</span>
                        </div>
                    </div>
                </template>
            </div>
        </div>
        <div class="Classification2">
            <div class="type">配送方式</div>
            <div class="list">
                <template v-for="(item,index) in deliveryList">
                    <div class="list-detail"
                         :key="index" v-if="item&&item.show">
                        <div class="detail-box">
                            <span class="num">{{item.count||0}}</span>
                            <span class="text">{{item.statusName}}</span>
                        </div>

                    </div>
                </template>
            </div>
        </div>
    </div>
</template>

<script>
import { deelingOata } from '../utils.js';
import config from '../config.js';

export default {
    components: {
    },
    props: {
        workbenchCheckData: {
            type: Object,
            default: () => {
                return {
                    endTime: '',
                    startTime: '',
                    siteCodes: '',
                    siteCodeNames: ''
                };
            }
        },
        classifyData: {
            type: Object,
            default: () => {
                return {
                    orderDeliveryTypeData: [],
                    orderTypeData: []
                };
            }
        },
        showKeys: {
            type: Array,
            default: () => {
                return [];
            }
        }
    },
    data () {
        return {
            config
        };
    },
    computed: {
        deliveryList () {
            const arr = deelingOata(this.classifyData.orderDeliveryTypeData || [], this.showKeys, config.orderDeliveryDataConfig);
            return arr;
        },
        orderList () {
            const arr = deelingOata(this.classifyData.orderTypeData || [], this.showKeys, config.orderTypeDataConfig);
            return arr;
        }

    },
    methods: {}
};
</script>

<style lang="less" scoped>
.order-Classification {
    width: 100%;
    flex: 1;
    display: flex;
    flex-direction: column;

    .Classification1 {
        display: flex;
        flex-direction: column;
        margin: 0 1.25vw 1.25vw 1.25vw;
        padding-bottom: 1.25vw;
        flex: 1;
        border-bottom: 1px solid #e5e6eb;
    }
    .Classification2 {
        display: flex;
        flex-direction: column;
        padding-bottom: 1.25vw;
        margin: 0 1.25vw 0 1.25vw;
        flex: 1;
    }

    .type {
        font-size: .7292vw;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #1d2129;
    }

    .list {
        display: flex;
        flex-wrap: wrap;
        flex:1;
        .list-detail {
            display: flex;
            flex-basis: calc(20% - 1.25vw);
            box-sizing: border-box;
            padding: .7813vw 0 0 0;
            margin-left: 1.5625vw;
            align-items: center;
            &:nth-child(5n-4) {
             margin-left: 0; /* 两行十个作用1/6盒子左边距 */
            }
            .detail-box{
                display: flex;
                min-width: 2.5vw;
                height: 2.8125vw;
                flex-direction: column;
                align-items: center;
                justify-content: space-between;
            }
            .num {
                display: block;
                line-height: 1.5625vw;
                height: 1.5625vw;
                font-size:  clamp(0.625rem, 1.1458vw, 1.1458vw);
                font-family: PingFangSC-Semibold, PingFang SC;
                font-weight: 600;
                color: #1d2129;
            }

            .text {
                display: block;
                line-height: 1.04167vw;
                height: 1.04167vw;
                font-size: clamp(0.5rem, 0.625vw, 0.625vw);
                font-family: PingFangSC-Regular, PingFang SC;
                color: #4e5969;
            }
        }
    }
}

</style>
